import { defineMessages } from 'react-intl';

export const sampleOrderLinkMessages = defineMessages({
  modalHeadline: {
    defaultMessage: 'Kostenlose Musterbestellung',
    id: 'sampleOrder.modalHeadline',
  },
  UPHOLSTERY: {
    defaultMessage: 'Kostenlos Stoffmuster bestellen',
    id: 'sampleOrderCtA.link.fabricPattern',
  },
  WOOD: {
    defaultMessage: 'Kostenlos Holzmuster bestellen',
    id: 'sampleOrderCtA.link.woodPattern',
  },
});
